import React from 'react';
import "./Footer.css";

function Footer() {
    return (
        <div className='footer'>
            Made with {"< />"}
            by Tarun</div>
    )
}

export default Footer
